module.exports = __webpack_public_path__ + "img/ico_upload_image.e94b425c.svg";